import React, { memo, useState, useEffect } from "react";
import Header from "../Components/Header";
import PageTitleSection from "../Components/PageTitleSection";
import FooterSection from "../Components/FooterSection";
import Spacer from "../Components/Spacer";
import PlainContent from "../Components/PlainContent";
import HttpHelper from '../service/httpService'
import SliderBrands from "../Components/SliderBrands";

const Clients = (props) => {

    const [clients, setClients] = useState([]);

    const getClients = async () => {
        await HttpHelper.get("website/GetClients").then((response) => {
            if (response.status === 200) {
                setClients(response.data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }


    useEffect(() => {
        getClients();
    }, [])

    return (<>
        <Header />
        <PageTitleSection
            title="Our Clients"
            pagetitle="Clients"
            subtitle="" />
       
        <PlainContent bgClass="blackBg">
            {
                clients && clients.length > 0 ? clients.map((client, index) => {
                    return (
                        <div>
                           
                             
                            <h2 className="mb-2">{client.name}</h2>
                                    <div className="mb-5" dangerouslySetInnerHTML={{ __html: client.description && client.description }}></div>
                              
                        </div>
                    )
                }) : null
            }
        </PlainContent>
        <SliderBrands data={clients}
            bgClass="blackBg"
        ></SliderBrands>
        <FooterSection />
    </>)
}

export default Clients;